import { useQuery } from "@tanstack/react-query";
import viewsApi from "@/api/views/client";

const useView = (nftId: string | undefined) => {
  const { data } = useQuery({
    queryKey: ["nft-views-count", nftId],
    queryFn: () =>
      nftId ? viewsApi.getNftViewsCount(nftId) : Promise.resolve(0),
  });

  return { viewsCount: data };
};

export default useView;
